/**
 * ML Split Slider — autoplay, infinite loop, progress ring on next arrow
 */
(function () {
  const ROOT_SELECTOR = '[data-ml-split-slider]';

  const restartProgress = (root) => {
    root.classList.remove('is-autoplaying');
    void root.offsetWidth;
    root.classList.add('is-autoplaying');
  };

  const initSlider = (root) => {
    const slides = Array.from(root.querySelectorAll('[data-slide]'));
    const slideCount = slides.length;
    if (slideCount === 0) return;

    let current = 0;
    let timer = null;
    const autoplayMs = parseInt(root.dataset.autoplay, 10) || 5000;
    const autoplayEnabled = root.dataset.autoplayEnabled !== 'false' && slideCount > 1;

    root.style.setProperty('--ml-split-autoplay-duration', `${autoplayMs}ms`);

    const setActive = (index) => {
      current = ((index % slideCount) + slideCount) % slideCount;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === current);
        slide.setAttribute('aria-hidden', i === current ? 'false' : 'true');
      });
    };

    const stopAutoplay = () => {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
      root.classList.remove('is-autoplaying');
    };

    const scheduleAutoplay = () => {
      stopAutoplay();
      if (!autoplayEnabled) return;

      restartProgress(root);
      timer = setTimeout(() => {
        setActive(current + 1);
        scheduleAutoplay();
      }, autoplayMs);
    };

    root.querySelector('[data-ml-split-prev]')?.addEventListener('click', () => {
      setActive(current - 1);
      scheduleAutoplay();
    });

    root.querySelector('[data-ml-split-next]')?.addEventListener('click', () => {
      setActive(current + 1);
      scheduleAutoplay();
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', scheduleAutoplay);
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', (event) => {
      if (root.contains(event.relatedTarget)) return;
      scheduleAutoplay();
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopAutoplay();
      } else {
        scheduleAutoplay();
      }
    });

    setActive(0);
    scheduleAutoplay();
  };

  const boot = () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initSlider);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target?.querySelector?.(ROOT_SELECTOR);
    if (root) initSlider(root);
  });
})();
